const normalizeArrayValue = (value) => (
  Array.isArray(value)
    ? value.map((item) => String(item ?? '').trim()).filter(Boolean).sort()
    : []
)

export const normalizeAdminReportStudentName = (value) => (
  String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
)

export const buildDefaultAdminReportFilters = () => ({
  course_id: '',
  course_ids: [],
  class_id: '',
  class_ids: [],
  company_id: '',
  company_ids: [],
  partner_id: '',
  partner_ids: [],
  student_name: '',
  status: '',
  statuses: [],
  enrollment_status: '',
  enrollment_statuses: [],
  never_accessed: false,
  parecer: '',
  pareceres: [],
  period: 'all_time',
  start_date: '',
  end_date: '',
})

export const filterAdminReportStudentsByName = (students, term) => {
  const normalizedTerm = normalizeAdminReportStudentName(term)
  if (!normalizedTerm) return Array.isArray(students) ? students : []

  return (Array.isArray(students) ? students : []).filter((student) => (
    normalizeAdminReportStudentName(student?.student).includes(normalizedTerm)
  ))
}

export const buildAdminReportStudentAutocompleteOptions = (students) => {
  const uniqueNames = new Map()

  for (const student of (Array.isArray(students) ? students : [])) {
    const rawName = String(student?.student ?? '').trim()
    const normalizedName = normalizeAdminReportStudentName(rawName)
    if (!rawName || !normalizedName || uniqueNames.has(normalizedName)) continue
    uniqueNames.set(normalizedName, rawName)
  }

  return Array.from(uniqueNames.values())
    .sort((left, right) => left.localeCompare(right, 'pt-BR', { sensitivity: 'base' }))
    .map((name) => ({ id: name, name }))
}

const areFilterValuesEqual = (currentValue, defaultValue) => {
  if (Array.isArray(defaultValue)) {
    const currentArray = normalizeArrayValue(currentValue)
    const defaultArray = normalizeArrayValue(defaultValue)
    if (currentArray.length !== defaultArray.length) return false
    return currentArray.every((item, index) => item === defaultArray[index])
  }

  if (typeof defaultValue === 'boolean') {
    return Boolean(currentValue) === defaultValue
  }

  return String(currentValue ?? '').trim() === String(defaultValue ?? '').trim()
}

export const hasActiveReportFilters = (filters, defaultFilters) => {
  const defaults = defaultFilters && typeof defaultFilters === 'object' ? defaultFilters : {}
  const current = filters && typeof filters === 'object' ? filters : {}

  return Object.keys(defaults).some((key) => !areFilterValuesEqual(current[key], defaults[key]))
}
